module.exports = __webpack_public_path__ + "static/media/appealHead.3f712393.svg";